import React from "react";
// Page Components
import AboutSection from "../components/AboutSection";
// Animations
import { motion } from 'framer-motion';
import { pageAnimation } from "../animation";

const About = () => {
    return(
        <motion.div
            variants={pageAnimation} 
            initial="hidden" 
            exit="exit" 
            animate="show"
        >
            <AboutSection />
        </motion.div>
    );
};

export default About;